import { __decorate } from "tslib";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DashboardRoutingModule } from "./dashboard-routing.module";
import { AflaModulesListComponent } from "./afla-modules-list/afla-modules-list.component";
import { AflaModuleComponent } from "./afla-module/afla-module.component";
import { MatGridListModule } from "@angular/material/grid-list";
import { AflaModuleStatusComponent } from "./afla-module-status/afla-module-status.component";
import { PhasesComponent } from "./phases/phases.component";
import { SharedModule } from "../../shared/shared.module";
import { DisclaimerDialogBodyComponent } from "./disclaimer-dialog-body/disclaimer-dialog-body.component";
import { MatDialogModule } from "@angular/material/dialog";
let DashboardModule = class DashboardModule {
};
DashboardModule = __decorate([
    NgModule({
        declarations: [AflaModulesListComponent, AflaModuleComponent, AflaModuleStatusComponent, PhasesComponent, DisclaimerDialogBodyComponent],
        imports: [
            CommonModule,
            DashboardRoutingModule,
            MatGridListModule,
            SharedModule,
            MatDialogModule
        ]
    })
], DashboardModule);
export { DashboardModule };
